'use client';

/*
 * Documentation:
 * Progress — https://app.subframe.com/6fc7f5fbb098/library?component=Progress_60964db0-a1bf-428b-b9d5-f34cdf58ea77
 */
import { c as _c } from "react/compiler-runtime";
import React from 'react';
import * as SubframeCore from '@subframe/core';
import * as SubframeUtils from '../utils';
interface IndicatorProps extends React.ComponentProps<typeof SubframeCore.Progress.Indicator> {
  className?: string;
}
const Indicator = React.forwardRef<HTMLDivElement, IndicatorProps>(function Indicator(t0, ref) {
  const $ = _c(11);
  let className;
  let otherProps;
  if ($[0] !== t0) {
    ({
      className,
      ...otherProps
    } = t0);
    $[0] = t0;
    $[1] = className;
    $[2] = otherProps;
  } else {
    className = $[1];
    otherProps = $[2];
  }
  let t1;
  if ($[3] !== className) {
    t1 = SubframeUtils.twClassNames("bg-brand-600 flex h-2 w-full flex-col items-start gap-2 rounded-full", className);
    $[3] = className;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  let t2;
  if ($[5] !== ref || $[6] !== t1) {
    t2 = <div className={t1} ref={ref} />;
    $[5] = ref;
    $[6] = t1;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  let t3;
  if ($[8] !== otherProps || $[9] !== t2) {
    t3 = <SubframeCore.Progress.Indicator asChild={true} {...otherProps}>{t2}</SubframeCore.Progress.Indicator>;
    $[8] = otherProps;
    $[9] = t2;
    $[10] = t3;
  } else {
    t3 = $[10];
  }
  return t3;
});
interface ProgressRootProps extends React.ComponentProps<typeof SubframeCore.Progress.Root> {
  value?: number;
  className?: string;
}
const ProgressRoot = React.forwardRef<HTMLDivElement, ProgressRootProps>(function ProgressRoot(t0, ref) {
  const $ = _c(14);
  let className;
  let otherProps;
  let t1;
  if ($[0] !== t0) {
    ({
      value: t1,
      className,
      ...otherProps
    } = t0);
    $[0] = t0;
    $[1] = className;
    $[2] = otherProps;
    $[3] = t1;
  } else {
    className = $[1];
    otherProps = $[2];
    t1 = $[3];
  }
  const value = t1 === undefined ? 30 : t1;
  let t2;
  if ($[4] !== className) {
    t2 = SubframeUtils.twClassNames("flex w-full flex-col items-start gap-2 overflow-hidden rounded-full bg-neutral-100", className);
    $[4] = className;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  let t3;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <Indicator />;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== ref || $[8] !== t2) {
    t4 = <div className={t2} ref={ref}>{t3}</div>;
    $[7] = ref;
    $[8] = t2;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  let t5;
  if ($[10] !== otherProps || $[11] !== t4 || $[12] !== value) {
    t5 = <SubframeCore.Progress.Root asChild={true} value={value} {...otherProps}>{t4}</SubframeCore.Progress.Root>;
    $[10] = otherProps;
    $[11] = t4;
    $[12] = value;
    $[13] = t5;
  } else {
    t5 = $[13];
  }
  return t5;
});
export const Progress = Object.assign(ProgressRoot, {
  Indicator
});